<template>
  <!-- Пример использования -->
  <!-- <Table
        maxWidth="500"          - максимальная ширина таблицы
        @handleSettings         - событие для вызова попапа/скрытия попапа настройки столбцов
        singleSelect            - одиночный выбор
        @current-change         - cобытие обработки одиночного выбора
        multipleSelect          - множественный выбор
        @handleSelection        - событие обработки множественного выбора
        @handleView             - событие обработки просмотра записи (скачивания файла)
        @handleDelete           - событие обработки удаления записи
  /> -->
  <div class="table__wrapper" ref="tableWrapper">
    <div v-if="+heightTable" style="width: 100%">
      <el-table
        :height="heightTable"
        :data="tableData"
        header-cell-class-name="table-header__cell"
        row-class-name="table-row"
        cell-class-name="table-row__cell"
        style="width: 100%"
        :highlight-current-row="singleSelect"
        @cell-click="(row, column) => cellClick(row, column)"
        @row-click="(row, column) => rowClick(row, column)"
      >
        <el-table-column
          v-for="elem in Object.keys(tableColumns)"
          :key="elem"
          :prop="elem"
          :label="tableColumns[elem].lbl.value || tableColumns[elem].name"
          show-overflow-tooltip
          :width="tableColumns[elem].width || ''"
        >
          <template v-if="elem !== 'delete'" slot-scope="scope">
            <p
              v-if="elem == 'status_label'"
              :class="[
                'status-tag',
                scope.row['status'] == 'last_day'
                  ? 'status-tag--yellow'
                  : scope.row['status'] == 'expired'
                  ? 'status-tag--red'
                  : ''
              ]"
            >
              {{ columnValue(scope.row[elem]) || '' | format }}
            </p>
            <p v-else>
              {{ columnValue(scope.row[elem]) || '' | format }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          v-if="(tableColumns && tableColumns.delete) || allowDelete"
          width="40px"
        >
          <template slot-scope="scope">
            <Button
              v-if="scope.row.id"
              buttonColor="transparent"
              buttonSize="small"
              hasLeftIcon
              iconName="delete-trash"
              iconColor="#62717E"
              class="row-options__button"
              @click="deleteRow(scope.$index, tableData)"
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="showActionColumn"
          label="Действие"
          property="action"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <a
              class="table-row__link"
              @click="
                goToCompare(
                  scope.row.parent_candidate_id,
                  scope.row.duplicate_candidate_id
                )
              "
            >
              Сравнить
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { MODULE } from '@/utils/constants';
import { mixin } from '@/utils/mixins';
import { Table, TableColumn } from 'element-ui';
import Button from '../Button/Button';

export default {
  mixins: [mixin],
  props: {
    module: {
      type: String,
      default: ''
    },
    singleSelect: Boolean,
    multipleSelect: Boolean,
    tableColumns: {
      type: Object,
      default: () => {
        return {};
      }
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    allowDelete: {
      type: Boolean,
      default: false
    },
    subpanelName: {
      type: String,
      default: ''
    },
    showActionColumn: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentRow: null,
      resizeObserver: null,
      multipleSelection: []
    };
  },
  computed: {
    heightTable() {
      return this.height.length
        ? this.height
        : this.tableData.length
        ? this.tableData.length * 49 + 51
        : '0';
    }
  },
  methods: {
    rowClick(row, column) {
      if (
        this.module === MODULE.HRPAC_CANDIDATES_DUPLICATES ||
        this.module === MODULE.VACANCY_MODULE
      ) {
        let route = null;
        if (this.module === MODULE.HRPAC_CANDIDATES_DUPLICATES) {
          route =
            column.property !== 'action'
              ? this.$router.resolve(`/candidates/${row?.id?.value}`)
              : null;
        } else {
          route = this.$router.resolve(
            `/vacancies/${row.vacancy_id?.value || row.vacancy_id}`
          );
        }
        if (route) {
          window.open(route.href, '_blank');
        }
      }
    },
    goToCompare(parent, double) {
      if (parent?.value && double?.value && parent?.value !== double?.value) {
        this.$router.push({
          name: 'candidateCompareId',
          params: {
            id: parent?.value,
            dublicateId: double?.value
          }
        });
      }
    },
    columnValue(field) {
      if (field?.name === 'work_site' && !field.value) {
        field.value = 'career';
      }

      if (field?.value) {
        if (
          field.options &&
          Object.keys(field.options) &&
          field.name.indexOf('date') < 0
        ) {
          return field.options[field.value]; // subpanelName
        } else if (this.subpanelName == 'event' && field.name == 'date_start') {
          return field.value.split(' ')[1];
        } else {
          return field.value;
        }
      } else if (field) {
        return typeof field == 'object' && Object.keys(field).length
          ? field.value
          : field;
      }
    },
    async cellClick(row, column) {
      if (column.property == 'filename') {
        this.$emit('downloadFile', row.id.value);
      } else if (
        column.property === 'vacancy_name' &&
        row.vacancy_id &&
        this.module !== MODULE.VACANCY_MODULE
      ) {
        const route = this.$router.resolve(
          `/vacancies/${row.vacancy_id?.value || row.vacancy_id}`
        );
        window.open(route.href, '_blank');
      } else if (column.property === 'candidate_name' && row.candidate_id) {
        const route = this.$router.resolve(
          `/candidates/${row.candidate_id?.value || row.candidate_id}`
        );
        window.open(route.href, '_blank');
      } else if (
        column.property === 'action' &&
        this.module === MODULE.HRPAC_CANDIDATES_DUPLICATES
      ) {
        this.goToCompare(row?.duplicate_candidate_id, row?.id);
      } else if (column.property && column.fixed !== 'right') {
        this.$emit('rowClick', row);
      }
    },

    deleteRow(index, rows) {
      this.$emit('handleDelete', rows[index]);
      // rows.splice(index, 1); // удаляет запись перед подтверждением ???????
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    Button
  }
};
</script>

<style lang="scss" scoped>
.table {
  &__wrapper {
    display: flex;
    height: 100%;
    position: inherit;

    .status-tag {
      width: unset;
      border-radius: 4px;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      padding: 2px 8px;
      width: min-content;

      &--yellow {
        background: $yellow;
        color: $grey80;
      }

      &--red {
        color: $white;
        background: $red;
      }
    }
  }

  &-settings {
    padding: 12px 0;
    background-color: transparent;
    display: flex;
    position: absolute;
    width: 64px;
    justify-content: center;
    z-index: 1000;

    &__button {
      display: flex;
      align-items: center;
      padding-right: 14px;
    }

    &__gradient {
      width: 24px;
      background: linear-gradient(
        270deg,
        #ffffff 3.13%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  &-row__link {
    color: $blue64;
  }
}

.el-table {
  width: 100%;
  border: 1px solid $grey8;
  border-radius: 4px;

  & ::v-deep .el-table__body-wrapper {
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  &.el-table--scrollable-x {
    border-bottom: none;
  }

  & ::v-deep .table {
    &-header {
      &__cell {
        color: $grey64;
        max-height: 57px;

        & > .cell {
          line-height: 20px;
          white-space: nowrap;
        }

        &:first-of-type {
          padding: 14px 0;

          & > .cell {
            padding: 0px 8px 0px 16px;
          }
        }

        &:not(:first-of-type) {
          & > .cell {
            padding: 0px 8px;
          }
        }
      }
    }

    &-row {
      cursor: pointer;
      &:hover {
        & > .table-row__cell {
          background-color: $blue8 !important;
        }
      }

      &:last-child {
        .el-table__cell {
          height: 49px;
          border-bottom: none;
        }
      }

      &__cell {
        color: $grey64;

        .cell {
          color: $grey80;
          font-size: 15px;
          line-height: 24px;
          p {
            cursor: pointer;
          }
        }

        &--name {
          display: flex;
          gap: 8px;
          align-items: center;
          cursor: pointer;

          a {
            text-decoration: none;
          }
        }

        &--user-text {
          display: flex;
          align-items: center;

          svg {
            min-width: 16px;
            width: 16px;
            height: 16px;
          }
        }

        p {
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &:first-of-type {
          padding: 12px 0;

          & > .cell {
            padding: 0px 8px 0px 16px;
          }
        }

        &:not(:first-of-type) {
          & > .cell {
            padding-top: 0;
            padding-bottom: 0;
          }
        }
      }
    }
  }

  & ::v-deep .el-checkbox {
    & > .is-indeterminate {
      & > .el-checkbox__inner {
        background-image: url('../../../assets/img/checkbox-indeterminate.svg') !important;
        width: 20px;
        height: 20px;
        border: none;
      }

      &::after {
        content: none;
      }
    }

    & > .is-checked {
      & > .el-checkbox__inner {
        background-image: url('../../../assets/img/checkbox-checked_blue.svg') !important;
        width: 20px;
        height: 20px;
        border: none;

        &::after {
          content: none;
        }
      }
    }

    & .el-checkbox__inner {
      background-image: url('../../../assets/img/checkbox_square.svg') !important;
      width: 20px;
      height: 20px;
      border: none;
      background-color: transparent;

      &::after {
        content: none;
      }

      &::before {
        display: none;
      }
    }
  }

  &::before {
    height: 0;
  }
}

.row-options {
  display: flex;

  &-buttons {
    display: flex;
    gap: 8px;
  }

  &__button {
    width: 24px;
    height: 24px;
    margin: 0 !important;
    background-color: transparent !important;

    &:focus {
      outline: none;
    }
  }
}

.el-button {
  display: flex;
  justify-self: center;
  background-color: $white;

  & ::v-deep .button-content {
    margin: 0 !important;
  }
}

.align-right {
  text-align: right;
}
</style>
